import React, { use, useState } from "react";
import AddNotificationView from "./AddNotificationView";

import { PlusThinWhiteIcon, NotificationBlackIcon, DeleteRedIcon } from "../../../assets/icons";
import { NotificationSettingsListItemDTO } from "../../../models/notification/notification.response";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { notificationService } from "../../../services/notificationService";
import { useParams } from "react-router-dom";
import { confirmDialog } from "../../../utils/confirmDialog";
import EditNotificationView from "./EditNotificationView";
import { NotificationType } from "../../../models/base/NotificationType";

const NotificationPage: React.FC = () => {

    const [isAddNotificationView, setIsAddNotificationView] = useState(false);
    const [isEditNotificationView, setIsEditNotificationView] = useState(false);

    const [notificationId, setNotificationId] = useState<string>("");
    const [notifications, setNotifications] = useState<NotificationSettingsListItemDTO[]>([]);

    const [loading, setLoading] = useState(false);

    const { notify } = useNotification();

    const { localId } = useParams<{ localId: string }>();

    React.useEffect(() => {
        fetchNotifications();
    }, [localId]);


    const fetchNotifications = async () => {
        if (!localId) return;

        setLoading(true);

        try {
            const response = await notificationService.getNotificationsByLocalId(localId);

            if (response.success && response.data) {
                setNotifications(response.data);
            } else {
                notify("error", response.message || "Došlo je do greške prilikom učitavanja notifikacija.");
            }
        } catch (error) {
            notify("error", "Došlo je do greške prilikom učitavanja notifikacija.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (notificationId: string) => {
        if (!localId) { 
            notify("error", "Local ID is missing.");
            return;
        }

        let confirm = await confirmDialog({
            title: "Potvrda brisanja",
            description: "Da li ste sigurni da želite da obrišete ovu notifikaciju?",
            isDelete: true
        })

        if (!confirm) return;

        setLoading(true);

        try {
            const response = await notificationService.deleteNotification(localId, notificationId);

            if (response.success) {
                notify("success", "Notifikacija je uspešno obrisana.");
                fetchNotifications();
            }
            else {
                notify("error", response.message || "Došlo je do greške prilikom brisanja notifikacije.");
            }
        } catch (error) {
            notify("error", "Došlo je do greške prilikom brisanja notifikacije.");
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return <Loader />;
    }

    return (
        <>

            {isAddNotificationView && (
                <AddNotificationView
                    onClose={() => {
                        setIsAddNotificationView(false)
                        fetchNotifications();
                    }}
                />
            )}

            {isEditNotificationView && (
                <EditNotificationView
                    notificationId={notificationId}
                    onClose={() => {
                        setIsEditNotificationView(false)
                        fetchNotifications();
                    }}
                />
            )}

            <section className="notification-section">
                <div className="w-layout-blockcontainer container notification w-container">
                    <div className="notification-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Notifikacije</h2>
                                <div className="text-block">
                                    Upravljajte pozdravnim porukama i obaveštenjima za goste<br />
                                </div>
                            </div>
                            <div className="header-button-div">
                                <div className="button-primary" onClick={() => setIsAddNotificationView(true)}>
                                    <img loading="lazy" src={PlusThinWhiteIcon} alt="" className="button-image" />
                                    <div className="button-text">Nova notifikacija</div>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div notification-list-block">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Sve stavke</div>
                                    <div className="list-header-description">
                                        Ukupno stavki: {notifications.length} ({notifications.filter(n => !n.isDeleted).length} aktivnih)<br />
                                    </div>
                                </div>
                            </div>
                            <div className="notification-list-div">

                                {notifications.map((notification) => (
                                    <div className="admin-settings-box-div notification-div">
                                        <div>
                                            <img loading="lazy" src={NotificationBlackIcon} alt="" className="icon-size-24" />
                                        </div>
                                        <div className="notification-info-div" id="w-node-_784b75b9-7580-94fe-59b3-83eda5076a99-1cee91cf">
                                            <div className="div-block-4">
                                                <div className="notification-title">{notification.title}</div>
                                                <div className="notification-type-div">
                                                    <div className="notification-type">{NotificationType[notification.notificationType]}</div>
                                                </div>
                                            </div>
                                            <div className="notification-text">{notification.message}</div>
                                            <div className="notification-action-div">
                                                <div className="small-box-div pointer"
                                                    onClick={() => {
                                                        setNotificationId(notification.id);
                                                        setIsEditNotificationView(true);
                                                    }}>
                                                    <div style={{fontWeight : "normal"}}>Izmeni</div>
                                                </div>
                                                <img loading="lazy" src={DeleteRedIcon} alt="" className="icon-size-20 pointer" onClick={() => handleDelete(notification.id)}/>
                                            </div>
                                        </div>
                                        {
                                            notification.isDeleted ? (
                                                <div id="w-node-_784b75b9-7580-94fe-59b3-83eda5076aa8-1cee91cf" className="small-box-div grey-bg">
                                                    <div className="notification-status">Neaktivna</div>
                                                </div>
                                            ) : (
                                                <div id="w-node-_784b75b9-7580-94fe-59b3-83eda5076aa8-1cee91cf" className="small-box-div green-bg">
                                                    <div className="notification-status">Aktivna</div>
                                                </div>
                                            )
                                        }

                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default NotificationPage;